import React, { useState, useContext, useEffect } from "react";
import styled from "styled-components";
import Input from "./Input";
import { FormContext } from "./Form";

const Container = styled.div``;

const Label = styled.label`
	display: block;
	margin-bottom: 6px;
	color: #808080;
`;

const Error = styled.div`
	margin-top: 8px;
	color: #f44336;
	font-size: 13px;
	font-weight: 400;
	:empty {
		display: none;
	}
`;

const Field = ({
	label,
	required,
	validate: customValidation,
	value,
	...other
}) => {
	const { validateOnFormSubmit = () => () => {} } = useContext(FormContext);

	const [errorMsg, setErrorMsg] = useState();

	const [touched, setTouched] = useState(false);
	const touch = () => setTouched(true);

	const validate = () => {
		const valid =
			(required && !value) ||
			(customValidation && !customValidation(value))
				? false
				: true;
		setErrorMsg(valid ? null : `Please enter a valid ${label}`);
		return valid;
	};

	useEffect(() =>
		validateOnFormSubmit(() => {
			touch();
			return validate();
		})
	);

	const shownErrorMsg = touched ? errorMsg : undefined;

	return (
		<Container>
			<Label hasError={shownErrorMsg ? true : false}>
				{label}
				{required ? "*" : ""}
			</Label>
			<Input
				{...other}
				value={value}
				hasError={shownErrorMsg ? true : false}
				onFocus={touch}
				onBlur={validate}
			/>
			<Error>{shownErrorMsg}</Error>
		</Container>
	);
};

export default Field;
